import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconPlug, IconPlugX } from '@tabler/icons-react';

import { useConnectPage, useDisconnectPage } from '../../../../api';
import { Platform } from '../../../../types';

import { ConfirmModal } from '@/components/Modals/Confirm';

type Props = {
  pageId: string;
  isConnected: boolean;
  isRestoring?: boolean;
  platform: Platform;
};

export const ConnectButton = ({ pageId, isConnected, isRestoring, platform }: Props) => {
  const connect = useConnectPage();
  const disconnect = useDisconnectPage();

  if (isRestoring) {
    return (
      <Tooltip label="Cannot connect while data is being restored from archive">
        <ActionIcon variant="filled" disabled radius="md" style={{ alignSelf: 'flex-start' }}>
          <IconPlugX />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (isConnected) {
    return (
      <Tooltip label="Disconnect Page">
        <ActionIcon
          loading={disconnect.isLoading}
          color="teal"
          onClick={() =>
            NiceModal.show(ConfirmModal, {
              title: 'Disconnect page?',
              onSuccess: () => disconnect.mutate({ pageId, platform }),
            })
          }
          radius="md"
          style={{ alignSelf: 'flex-start' }}
        >
          <IconPlug />
        </ActionIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Connect Page">
      <ActionIcon
        variant="filled"
        loading={connect.isLoading}
        onClick={() =>
          NiceModal.show(ConfirmModal, {
            title: 'Connect page?',
            onSuccess: () => connect.mutate({ pageId, platform }),
          })
        }
        radius="md"
        style={{ alignSelf: 'flex-start' }}
      >
        <IconPlugX />
      </ActionIcon>
    </Tooltip>
  );
};
